import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MoneyInput } from "@/components/common/MoneyInput";
import { rangoVencimiento } from "@/lib/factoraje";

/** Simulador · Factoraje: solo factura (valor nominal, aforo y vencimiento). El anticipo lo calcula el backend. */
export function FactorajeSimForm({ form, set, producto }) {
  const rango = rangoVencimiento(producto?.plazo_max_dias_factura);
  return (
    <div className="space-y-3 rounded-md border border-indigo-200 bg-indigo-50/40 p-3" data-testid="sim-factoraje-form">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-indigo-900">Datos de la factura</p>
      <div>
        <Label className="mb-1 block text-xs font-medium text-slate-600">Valor nominal de la factura</Label>
        <MoneyInput data-testid="sim-fx-valor-nominal" value={form.valor_nominal} onChange={(v) => set("valor_nominal", v)} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="mb-1 block text-xs font-medium text-slate-600">
            Aforo (%) <span className="font-normal text-slate-400">(máx. {producto?.aforo_pct ?? "—"}%)</span>
          </Label>
          <Input data-testid="sim-fx-aforo" type="number" value={form.aforo_pct}
            onChange={(e) => set("aforo_pct", e.target.value)} />
        </div>
        <div>
          <Label className="mb-1 block text-xs font-medium text-slate-600">Vencimiento de la factura</Label>
          <Input data-testid="sim-fx-vencimiento" type="date" value={form.fecha_vencimiento_factura}
            min={rango.min} max={rango.max} onChange={(e) => set("fecha_vencimiento_factura", e.target.value)} />
        </div>
      </div>
      <p className="text-[11px] text-slate-500">
        Pago único al vencimiento. El anticipo (valor nominal × aforo) y el descuento por días exactos los calcula el
        sistema con la misma regla de la solicitud.
      </p>
    </div>
  );
}
